import React from 'react'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const StaffingEorTech = () => {
    const listItems = [
        "Paperless Onboarding & Contract Management: Contractors can be onboarded and verified digitally, streamlining the process and saving time.",
        "Payment Processing & Transaction Management: Our platform makes it easy to manage, approve, and process payments while staying compliant with local tax laws.",
        "Data Insights & Analytics: Real-time data and insights help you track placements and contractor status effortlessly",
        "Compliance Documentation: Access all necessary compliance documents and reports to ensure contractors and clients are protected.",
      ];
  return (
    <>
    <div className="wrapper">
        <div className="textcontentservice eortech">
            <h1>Tech Designed for <span>  Your Needs</span></h1>
            <p>At Ampstekpay, we focus on people, and in addition to our dedicated human support, we leverage our custom-built workforce management technology to improve your experience. Our contractor management platform allows you to manage onboarding, compliance, payments, and more—all in one place.</p>
            <p>By partnering with Ampstekpay, you gain access to: </p>
            <div className="listcontent">
                <ul>
                    {listItems.map((item, index) => (
                         <li key={index}><FontAwesomeIcon
                         icon={faCheckCircle} style={{
                            color: "rgb(255 102 204)", // Green color
                          }}/>&nbsp;&nbsp;&nbsp;{item}</li>
                    ))}
                </ul>
                <br/>
            </div>
            <p>Best of all, we consistently invest in our tech so that it evolves to meet the growing global needs of staffing firms.</p>
        </div>
    </div>
    </>
  )
}

export default StaffingEorTech